import { proxy } from 'valtio';
import { ERROR_MESSAGES } from '@/constants/messages';
import { handleError } from '@/utils/helpers';
import { addCustomTemplate, searchCustomTemplates, deleteCustomTemplate } from '@/services/api';

export interface CustomTemplateData {
  id?: string;
  title: string;
  info: string;
  userId: string;
  createTime?: number;
  updateTime?: number;
}

export interface CustomTemplateStore {
  data: CustomTemplateData[];
  isLoading: boolean;
  addLoading: boolean;
  deleteLoading: boolean;
  runFetch: (userId: string | undefined) => Promise<void>;
  addTemplate: (template: { title: string; info: string; userId: string }) => Promise<boolean>;
  deleteTemplate: (id: string, userId: string) => Promise<boolean>;
}

export const CustomTemplateStore = proxy<CustomTemplateStore>({
  data: [],
  isLoading: false,
  addLoading: false,
  deleteLoading: false,

  async runFetch(userId) {
    if (!userId) {
      handleError(null, ERROR_MESSAGES.USER_ID_ERROR, 'customTemplate');
      return;
    }
    
    CustomTemplateStore.isLoading = true;
    
    try {
      const response = await searchCustomTemplates({ userId });
      
      if (response.data.success) {
        CustomTemplateStore.data = response.data.data || [];
      } else {
        handleError(null, response.data.message || '获取自定义模板失败', 'customTemplate');
      }
    } catch (error) {
      handleError(error, '获取自定义模板失败', 'customTemplate');
    } finally {
      CustomTemplateStore.isLoading = false;
    }
  },

  async addTemplate(template) {
    CustomTemplateStore.addLoading = true;
    
    try {
      const response = await addCustomTemplate(template);
      
      if (response.data.success) {
        // 添加成功后重新获取列表
        await CustomTemplateStore.runFetch(template.userId);
        return true;
      } else {
        handleError(null, response.data.message || '添加自定义模板失败', 'customTemplate');
        return false;
      }
    } catch (error) {
      handleError(error, '添加自定义模板失败', 'customTemplate');
      return false;
    } finally {
      CustomTemplateStore.addLoading = false;
    }
  },

  async deleteTemplate(id, userId) {
    CustomTemplateStore.deleteLoading = true;
    
    try {
      const response = await deleteCustomTemplate({ id });
      
      if (response.data.success) {
        // 删除成功后重新获取列表
        await CustomTemplateStore.runFetch(userId);
        return true;
      } else {
        handleError(null, response.data.message || '删除自定义模板失败', 'customTemplate');
        return false;
      }
    } catch (error) {
      handleError(error, '删除自定义模板失败', 'customTemplate');
      return false;
    } finally {
      CustomTemplateStore.deleteLoading = false;
    }
  }
});